@import (reference) "../../references.less";

.root {
  .disableSelection();
}

.infos {
  @media (min-width: @breakpoint-laptop) {
    position: absolute;
    .R(margin-left, -320);
    .R(width, 300);
    text-align: right;
  }
}

.rank {
  color: @color-red;
  .R(font-size, 14, 18);
}

.filename {
  .R(margin-top, 2);
  .R(font-size, 14, 18);
  color: @color-grey-2;
}

.wrapper {
  .R(margin-top, 10);
  position: relative;
  @media (min-width: @breakpoint-laptop) {
    .R(margin-top, 0);
  }
}

.image {
  border-radius: 0.2em;
  position: relative;
  width: 100%;

  transition: opacity ease-out 200ms;

  &_isReady {
    opacity: 1;
  }
}

.overlay {
  pointer-events: none;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
}

.overlayLabel {
  .element-blink-animation();
  color: @color-white;
  .absoluteCenter();
  text-align: center;
  width: 100%;
}

.canvas {
  position: absolute;
  top: 0;
}

.blurZoneBuilder {
  top: 0;
  width: 100%;
  height: 100%;
  position: absolute;
}
